<template>
  <div class="stall-add-page">
    <!-- 顶部导航栏 -->
    <div class="page-top-bar">
      <div class="top-left" @click="goBack">
        <span class="back-icon">←</span>
      </div>
      <div class="top-title">{{ $t('wholesaler.StallAdd.line8_text') }}</div>
      <div class="top-right"></div>
    </div>

    <!-- 表单内容 -->
    <div class="form-container">
      <!-- 基本信息 -->
      <div class="section-title">
        <span class="section-number">1</span>
        <h3>{{ $t('wholesaler.StallAdd.line17_text') }}</h3>
      </div>

      <div class="form-group">
        <label for="customerName">
          <span class="icon">🏪</span>
          {{ $t('wholesaler.StallAdd.stallName') }}
        </label>
        <input
          id="customerName"
          v-model="formData.customerName"
          type="text"
          :placeholder="$t('wholesaler.StallAdd.line29_placeholder')"
          maxlength="50"
          required
        />
      </div>

      <div class="form-group">
        <label for="contactPerson">
          <span class="icon">👤</span>
          {{ $t('wholesaler.StallAdd.contactPerson') }}
        </label>
        <input
          id="contactPerson"
          v-model="formData.contactPerson"
          type="text"
          :placeholder="$t('wholesaler.StallAdd.line44_placeholder')"
          maxlength="30"
          required
        />
      </div>

      <div class="form-group">
        <label for="phone">
          <span class="icon">📞</span>
          {{ $t('wholesaler.StallAdd.contactPhone') }}
        </label>
        <input
          id="phone"
          v-model="formData.phone"
          type="tel"
          :placeholder="$t('wholesaler.StallAdd.line59_placeholder')"
          maxlength="20"
          required
        />
      </div>

      <!-- 区域选择 -->
      <div class="section-title">
        <span class="section-number">2</span>
        <h3>{{ $t('wholesaler.StallAdd.line68_text') }}</h3>
      </div>

      <div class="form-group">
        <label for="region">
          <span class="icon">📍</span>
          {{ $t('wholesaler.StallAdd.region') }}
        </label>
        <select id="region" v-model="formData.regionId" required>
          <option value="">{{ $t('wholesaler.StallAdd.line77_text') }}</option>
          <option v-for="region in regions" :key="region.id" :value="region.id">
            {{ region.regionName }}
          </option>
        </select>
      </div>

      <!-- 登录账号 -->
      <div class="section-title">
        <span class="section-number">3</span>
        <h3>{{ $t('wholesaler.StallAdd.line87_text') }}</h3>
      </div>

      <div class="form-group">
        <label for="username">
          <span class="icon">👤</span>
          {{ $t('wholesaler.StallAdd.username') }}
        </label>
        <input
          id="username"
          v-model="formData.username"
          type="text"
          :placeholder="$t('wholesaler.StallAdd.line99_placeholder')"
          maxlength="50"
          required
        />
      </div>

      <div class="form-group">
        <label for="password">
          <span class="icon">🔒</span>
          {{ $t('wholesaler.StallAdd.initialPassword') }}
        </label>
        <input
          id="password"
          v-model="formData.password"
          type="password"
          :placeholder="$t('wholesaler.StallAdd.line114_placeholder')"
          maxlength="50"
          required
        />
      </div>

      <!-- 备注 -->
      <div class="section-title">
        <span class="section-number">4</span>
        <h3>{{ $t('wholesaler.StallAdd.line123_text') }}</h3>
      </div>

      <div class="form-group">
        <label for="remark">
          <span class="icon">📝</span>
          {{ $t('wholesaler.StallAdd.remark') }}
        </label>
        <textarea
          id="remark"
          v-model="formData.remark"
          :placeholder="$t('wholesaler.StallAdd.line134_placeholder')"
          maxlength="200"
          rows="3"
        ></textarea>
      </div>

      <!-- 提交按钮 -->
      <button
        type="button"
        class="btn-submit"
        :class="{ loading: submitting }"
        :disabled="submitting"
        @click="handleSubmit"
      >
        <span v-if="!submitting">{{ $t('wholesaler.StallAdd.line148_text') }}</span>
        <span v-else>
          <span class="spinner"></span>
          {{ $t('wholesaler.StallAdd.submitting') }}
        </span>
      </button>
    </div>

    <!-- Toast 提示 -->
    <div v-if="toast.show" :class="['toast', `toast-${toast.type}`, { show: toast.show }]">
      {{ toast.message }}
    </div>
  </div>
</template>

<script>
import api from '@/services/api'

export default {
  name: 'StallAdd',
  data() {
    return {
      formData: {
        customerName: '',
        contactPerson: '',
        phone: '',
        regionId: '',
        username: '',
        password: '',
        remark: ''
      },
      regions: [],
      submitting: false,
      toast: {
        show: false,
        message: '',
        type: 'info'
      }
    }
  },
  mounted() {
    this.loadRegions()
  },
  methods: {
    goBack() {
      this.$router.back()
    },

    showToast(message, type = 'info') {
      this.toast = { show: true, message, type }
      setTimeout(() => {
        this.toast.show = false
      }, 3000)
    },

    async loadRegions() {
      try {
        const response = await api.get('/wholesaler/stalls/regions')
        // api 拦截器已解包，response 直接是数组
        this.regions = Array.isArray(response) ? response : (response?.data || response || [])
        console.log('📍 regions 列表:', this.regions)
      } catch (error) {
        console.error('加载区域列表失败:', error)
      }
    },

    async handleSubmit() {
      // 表单验证
      if (!this.formData.customerName) {
        this.showToast(this.$t('wholesaler.StallAdd.pleaseEnterStallName'), 'error')
        return
      }
      if (!this.formData.contactPerson) {
        this.showToast(this.$t('wholesaler.StallAdd.pleaseEnterContactPerson'), 'error')
        return
      }
      if (!this.formData.phone) {
        this.showToast(this.$t('wholesaler.StallAdd.pleaseEnterContactPhone'), 'error')
        return
      }
      if (!this.formData.regionId) {
        this.showToast(this.$t('wholesaler.StallAdd.pleaseSelectRegion'), 'error')
        return
      }
      if (!this.formData.username) {
        this.showToast(this.$t('wholesaler.StallAdd.pleaseEnterUsername'), 'error')
        return
      }
      if (!this.formData.password) {
        this.showToast(this.$t('wholesaler.StallAdd.pleaseSetPassword'), 'error')
        return
      }

      // 获取批发商ID
      const wholesalerId = localStorage.getItem('stored_wholesaler_id') || localStorage.getItem('identityId') || localStorage.getItem('wholesalerId')
      if (!wholesalerId) {
        this.showToast(this.$t('wholesaler.StallAdd.wholesalerNotFound'), 'error')
        return
      }

      this.submitting = true
      try {
        // 创建档口并建立归属关系
        await api.post('/wholesaler/stalls/create', {
          customerName: this.formData.customerName,
          contactPerson: this.formData.contactPerson,
          phone: this.formData.phone,
          regionId: this.formData.regionId,
          username: this.formData.username,
          password: this.formData.password,
          remark: this.formData.remark,
          wholesalerId: wholesalerId
        })

        this.showToast(this.$t('wholesaler.StallAdd.addSuccess'), 'success')
        setTimeout(() => {
          this.$router.push('/wholesaler/stalls')
        }, 1000)
      } catch (error) {
        console.error('添加档口失败:', error)
        const message = error.response?.data?.message || this.$t('wholesaler.StallAdd.addFailed')
        this.showToast(message, 'error')
      } finally {
        this.submitting = false
      }
    }
  }
}
</script>

<style scoped>
.stall-add-page {
  min-height: 100vh;
  background: #f5f7fa;
  padding-bottom: 40px;
}

/* 顶部导航栏 */
.page-top-bar {
  position: sticky;
  top: 0;
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 50px;
  background: #fff;
  border-bottom: 1px solid #eee;
  padding: env(safe-area-inset-top, 0px) 16px 0 16px;
}

.top-left, .top-right {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.back-icon {
  font-size: 20px;
  color: #333;
}

.top-title {
  font-size: 17px;
  font-weight: 600;
  color: #333;
}

/* 表单容器 */
.form-container {
  padding: 20px 16px;
}

/* 分区标题 */
.section-title {
  display: flex;
  align-items: center;
  margin: 24px 0 16px;
  gap: 12px;
}

.section-title:first-child {
  margin-top: 0;
}

.section-number {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 600;
}

.section-title h3 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #333;
}

/* 表单组 */
.form-group {
  margin-bottom: 16px;
}

.form-group label {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  color: #555;
  margin-bottom: 8px;
  font-weight: 500;
}

.form-group .icon {
  font-size: 16px;
}

.form-group input,
.form-group select,
.form-group textarea {
  width: 100%;
  padding: 12px 14px;
  border: 1px solid #e0e0e0;
  border-radius: 10px;
  font-size: 15px;
  background: #fff;
  transition: all 0.2s;
  box-sizing: border-box;
}

.form-group input:focus,
.form-group select:focus,
.form-group textarea:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.form-group input::placeholder,
.form-group textarea::placeholder {
  color: #bbb;
}

.form-group textarea {
  resize: vertical;
  min-height: 80px;
  font-family: inherit;
}

/* 提交按钮 */
.btn-submit {
  width: 100%;
  padding: 14px;
  margin-top: 32px;
  border: none;
  border-radius: 12px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.btn-submit:active {
  transform: scale(0.98);
}

.btn-submit:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.btn-submit.loading {
  background: #999;
}

.spinner {
  width: 16px;
  height: 16px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-top-color: #fff;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

/* Toast 提示 */
.toast {
  position: fixed;
  top: 80px;
  left: 50%;
  transform: translateX(-50%) translateY(-20px);
  padding: 12px 24px;
  border-radius: 8px;
  font-size: 14px;
  opacity: 0;
  transition: all 0.3s;
  z-index: 1000;
  max-width: 80%;
  text-align: center;
}

.toast.show {
  opacity: 1;
  transform: translateX(-50%) translateY(0);
}

.toast-success {
  background: #52c41a;
  color: #fff;
}

.toast-error {
  background: #ff4d4f;
  color: #fff;
}

.toast-info {
  background: #1890ff;
  color: #fff;
}
</style>
